import { QueryClient } from '@tanstack/react-query';
import { EnterpriseApi } from '../../../api/enterprise/enterprise.api';
import { WithErrorService } from '../../front/ErrorService/ErrorService';
import { WithServices } from '../../../platform/ts/services';
import { EnterpriseMutationService } from './EnterpriseMutationService';

export function createEnterpriseMutationService(
  config: WithServices<[WithErrorService]> & {
    api: EnterpriseApi;
    queryClient: QueryClient;
  }
): EnterpriseMutationService {
  const {
    api,
    queryClient,
    services: { errorService }
  } = config;
  const interceptor = errorService.withCategory('EnterpriseMutationService');

  async function invalidateEnterpriseQueries() {
    await queryClient.invalidateQueries({ queryKey: ['enterprise'] });
  }

  return {
    createWorkspace: async input => {
      const result = await interceptor.wrap(() => api.createWorkspace(input))();
      await invalidateEnterpriseQueries();
      return result;
    },
    updateWorkspace: async input => {
      const result = await interceptor.wrap(() => api.updateWorkspace(input))();
      await invalidateEnterpriseQueries();
      return result;
    },
    archiveWorkspace: async input => {
      const result = await interceptor.wrap(() =>
        api.archiveWorkspace(input)
      )();
      await invalidateEnterpriseQueries();
      return result;
    },
    createTeam: async input => {
      const result = await interceptor.wrap(() => api.createTeam(input))();
      await invalidateEnterpriseQueries();
      return result;
    },
    updateTeam: async input => {
      const result = await interceptor.wrap(() => api.updateTeam(input))();
      await invalidateEnterpriseQueries();
      return result;
    },
    archiveTeam: async input => {
      const result = await interceptor.wrap(() => api.archiveTeam(input))();
      await invalidateEnterpriseQueries();
      return result;
    }
  };
}
